// Calendar days in Paris, including weeks crossing daylight-saving changes.
export function weeklySchedule(monday) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(monday)) throw new Error('Choisis un lundi.');
  const day = new Date(`${monday}T00:00:00Z`);
  if (!Number.isFinite(day.getTime()) || day.toISOString().slice(0, 10) !== monday || day.getUTCDay() !== 1) throw new Error('Choisis un lundi.');
  const at = offset => {
    const date = new Date(day.getTime() + offset * 86400000);
    const hour = Number(new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', hour: '2-digit', hourCycle: 'h23' }).formatToParts(date).find(part => part.type === 'hour').value);
    return new Date(date.getTime() - hour * 3600000).toISOString();
  };
  return { starts_at: at(0), ends_at: at(7), releases: [at(0), at(2), at(4)] };
}
